/**
 * Shared URLs for Oddfish Shopify homepage embed.
 * Upload images to Shopify Files later and swap ASSET_BASE if needed.
 */
window.ODDFISH_SHOPIFY = {
  /** Vercel app — logos & office images until hosted on Shopify */
  ASSET_BASE: "https://oddfish-landing.vercel.app",
  /** Local Next audit app — switch to https://oddfish-landing.vercel.app before production */
  API_BASE: "https://oddfish-landing.vercel.app",
  SITE_NAME: "Oddfish Media",
};
